// Entry point for the build script in your package.json

import {Turbo} from "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "trix"

import "./controllers";

// UKCIL rich-text fields do not support embedded files. Hiding the toolbar
// control alone does not prevent files being pasted or dragged into Trix.
document.addEventListener("trix-file-accept", (event) => event.preventDefault())


Turbo.start();
ActiveStorage.start();


// function toggle_mobile_menu(event) {
//     event.preventDefault();
// }





